import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { Drawer, Descriptions, Divider, Tag, Row, Col, Typography, Button, Table } from 'antd'
import { ConvertcustomerGender, isValidDate } from '../../../utils/helpers';
import { isMobile } from 'react-device-detect';
import CustomerServicesList from './CustomerServicesList';
import HtmlParser from 'react-html-parser';
import { EditOutlined } from '@ant-design/icons';
import { getTreatmentNoteDetail } from '@/redux/actions/treatmentNoteActions';
import { getSpecificCustomerSchedule } from '@/redux/actions/CustomerScheduleActions';
import NoteForm from '../appointment/NoteForm';

const { Paragraph } = Typography;

class CustomerDetail extends Component {
    constructor() {
        super();
        this.state = {
            currentNote: null,
            isOpenFormNote: false
        };
    }

    handleCancel() {
        this.props.onCancel();
    }

    async handleEdit(isOpenFormNote, id) {
        try {
            const res = await this.props.getTreatmentNoteDetail(id);
            this.setState({
                isOpenFormNote: isOpenFormNote,
                currentNote: res,
            });
        } catch (err) {
            console.error("Lỗi khi lấy dữ liệu:", err);
        }
    }

    onCancelFormNote() {
        this.setState({ isOpenFormNote: false, currentNote: null });
    }

    render() {
        var { isOpenFormNote, currentNote } = this.state;
        var { visible, currentItem } = this.props;

        const columns3 = [
            {
                title: 'Nội dung',
                dataIndex: 'content',
                key: 'content',
                width: '250px',
                render: (text, record) => {
                    return (
                        <>{HtmlParser(record.content)}</>
                    )
                }
            },
            {
                title: 'Người nhập',
                dataIndex: 'created_by',
                key: 'created_by',
                width: '150px',
                render: (text, record) => {
                    return (
                        <>{record?.created_by?.full_name}</>
                    )
                }
            },
            {
                title: 'Bác sĩ xác nhận',
                dataIndex: 'confirmed_by',
                key: 'confirmed_by',
                width: '150px',
                render: (text, record) => {
                    return (
                        <>{record?.confirmed_by?.full_name}</>
                    )
                }
            },
            {
                title: 'Ngày tạo',
                dataIndex: 'created_at',
                key: 'created_at',
                width: '150px',
                render: (text, record) => {
                    return (
                        <>{isValidDate(record.created_at)}</>
                    )
                }
            },
            {
                title: '#',
                align: 'center',
                width: '50px',
                dataIndex: 'actions',
                key: 'actions',
                render: (text, record) => {
                    return (
                        <>
                            <Button
                                size="small"
                                type="dashed"
                                className='btn-edit'
                                icon={<EditOutlined />}
                                onClick={() => this.handleEdit(true, record.id)}
                            >Sửa</Button>
                        </>
                    );
                }
            }
        ];

        return (
            <>
                <Drawer
                    visible={visible}
                    title="Hồ sơ khách hàng"
                    onClose={() => this.handleCancel()}
                    maskClosable={false}
                    width={isMobile ? '100%' : '65%'}
                    bodyStyle={{ paddingTop: 0 }}
                >
                    {visible ? (
                        <div>
                            <Table
                                className='mb-4 custom-table'
                                title={() => <>Ghi chú điều trị</>}
                                rowKey="id"
                                size="small"
                                dataSource={currentItem?.treatment_note || []}
                                columns={columns3}
                                pagination={false}
                                scroll={{
                                    x: 'max-content'
                                }}
                                locale={{ emptyText: "Chưa có dữ liệu" }}
                            />
                            <Divider orientation="left" orientationMargin="0" style={{ marginTop: 0 }}>
                                <Tag color='#0b2b33'>1</Tag> Thông tin khách hàng
                            </Divider>
                            <Row gutter={16}>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Tên khách hàng">
                                            {currentItem ? currentItem.full_name : null}
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Mã khách hàng">
                                            <Paragraph style={{ margin: 0 }} copyable={
                                                {
                                                    text: currentItem ? currentItem.code : null,
                                                    tooltips: false
                                                }
                                            }>
                                                <Tag color='#1890ff'>{currentItem ? currentItem.code : null}</Tag>
                                            </Paragraph>
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Mã số sổ khám">
                                            {
                                                currentItem?.medical_book_number ? (
                                                    <Paragraph style={{ margin: 0 }} copyable={
                                                        {
                                                            text: currentItem ? currentItem.medical_book_number : null,
                                                            tooltips: false
                                                        }
                                                    }>
                                                        {currentItem ? currentItem.medical_book_number : null}
                                                    </Paragraph>
                                                ) : null
                                            }

                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Năm sinh">
                                            {currentItem?.birthday}
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Giới tính">
                                            {currentItem ? ConvertcustomerGender(currentItem.gender) : null}
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                            </Row>
                            <CustomerServicesList ref={this.servicesSelectedFormRef} currentItem={currentItem} reloadData={() => this.props.reloadData()} />
                        </div>
                    ) : null}
                </Drawer>

                <NoteForm
                    visible={isOpenFormNote}
                    currentItem={currentItem}
                    currentNote={currentNote}
                    onCancel={() => this.onCancelFormNote()}
                />
            </>
        )
    }
}
function mapStateToProps(state) {
    return {
        authUser: state.auth.authUser,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getTreatmentNoteDetail: (id) => dispatch(getTreatmentNoteDetail(id))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'CustomerDetail' })(CustomerDetail));
